import type { ComuneFull } from '@/data';
import type { Filters, Zone } from './types';

export const F_DEFAULTS: Filters = {
  alt_min: 0,
  alt_max: 3500,
  t_jul_max: null,
  t_jan_min: null,
  hum_max: null,
  snow_min: null,
  sunny_min: null,
  zones: new Set<Zone>(),
  pop_max: null,
  hosp_max: null,
};

export function isFilterActive(f: Filters): boolean {
  return (
    f.alt_min !== F_DEFAULTS.alt_min ||
    f.alt_max !== F_DEFAULTS.alt_max ||
    f.t_jul_max !== null ||
    f.t_jan_min !== null ||
    f.hum_max !== null ||
    f.snow_min !== null ||
    f.sunny_min !== null ||
    f.zones.size > 0 ||
    f.pop_max !== null ||
    f.hosp_max !== null
  );
}

export function matches(c: ComuneFull, f: Filters): boolean {
  if (c.alt < f.alt_min || c.alt > f.alt_max) return false;
  if (f.t_jul_max !== null && c.climate.t_jul > f.t_jul_max) return false;
  if (f.t_jan_min !== null && c.climate.t_jan < f.t_jan_min) return false;
  // Поля ниже есть не у каждой страны. Неизвестное значение НЕ удовлетворяет
  // активному фильтру по этому полю: пользователь просил «не больше 30 снежных
  // дней», а про эту единицу мы не знаем — молча выдать её за подходящую нельзя.
  // Когда фильтр по полю не задан, отсутствие данных ни на что не влияет.
  if (f.hum_max !== null && !(c.climate.hum != null && c.climate.hum <= f.hum_max)) return false;
  if (f.snow_min !== null && !(c.climate.snow != null && c.climate.snow >= f.snow_min)) return false;
  if (f.sunny_min !== null && !(c.climate.sunny != null && c.climate.sunny >= f.sunny_min)) return false;
  if (f.zones.size > 0 && !f.zones.has(c.zone as Zone)) return false;
  if (f.pop_max !== null && c.pop > f.pop_max) return false;
  if (f.hosp_max !== null && c.infra.hosp > f.hosp_max) return false;
  return true;
}
